module.exports = __webpack_public_path__ + "static/media/1551391304654542286799.56a550c9.jpg";